import React, { useEffect, useState } from 'react';
import clsx from 'clsx';
import styles from './styles.module.css';
import { Icon } from 'common/icon';

export const extractVideoId = (link: string) => {
  const regex =
    /(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?feature=player_embedded&v=|watch\?v=|embed\/videoseries\?list=|shorts\/))([^#\&\?]*).*/;
  const match = link.match(regex);

  if (match && match[1]) {
    return match[1];
  }

  return null;
};

export const YoutubeFrame = ({
  link,
  anchor,
  width = 180,
  height = 270,
  variant = 'withWrapper',
  fullScreen = false,
}: {
  anchor?: string;
  link: string;
  width?: number;
  height?: number;
  variant?: 'withWrapper' | 'withoutWrapper';
  fullScreen?: boolean;
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const classesIframe = clsx(styles.iframe_block);
  const videoId = extractVideoId(link);
  const iframeClassName = clsx({
    [styles.iframe]: variant === 'withWrapper',
  });

  const baseIframeUrl = `https://www.youtube.com/embed/${videoId}`;
  const defaultParams = '?autoplay=0';
  const modalParams = '?autoplay=1';

  // The standard iframe (non-modal version)
  const iframeElement = (
    <iframe
      autoFocus
      width={width}
      height={height}
      src={`${baseIframeUrl}${defaultParams}`}
      frameBorder="0"
      allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      allowFullScreen
      className={iframeClassName}
    ></iframe>
  );

  const handleClick = () => {
    if (fullScreen) {
      setIsModalOpen(true);
    }
  };

  useEffect(() => {
    const handleEsc = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        setIsModalOpen(false);
      }
    };

    window.addEventListener('keydown', handleEsc);

    return () => {
      window.removeEventListener('keydown', handleEsc);
    };
  }, []);

  return (
    <>
      <div
        id={anchor}
        className={classesIframe}
        style={{ position: 'relative' }}
      >
        {iframeElement}
        {/* Overlay to capture click events when fullscreen is enabled */}
        {fullScreen && <div className={styles.overlay} onClick={handleClick} />}
      </div>

      {isModalOpen && fullScreen && (
        <div className={styles.modal}>
          <div className={styles.modalContent}>
            <button
              className={styles.close}
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();

                setIsModalOpen(false);
              }}
            >
              <Icon.CloseSecond fill="#000" />
            </button>
            <iframe
              autoFocus
              width="100%"
              height="100%"
              src={`${baseIframeUrl}${modalParams}`}
              frameBorder="0"
              allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              className={iframeClassName}
            ></iframe>
          </div>
        </div>
      )}
    </>
  );
};
